module.exports = __webpack_public_path__ + "47e217dd2b24417d808d24db358f772e.svg";